<ion-content>
  <ion-row>
    <ion-col class="patient-sidebar">
      <app-patient-manager-sidebar [user]="user"></app-patient-manager-sidebar>
    </ion-col>
    <ion-col class="patient-content">
      <ion-title>Patient Portal</ion-title>
      <form id="patient-form" *ngIf="patientForm" [formGroup]="patientForm" novalidate>
        <div class="patient-section-title">
          <i class="icon-patient"></i>
          <span class="patient-header" *ngIf="mode.add">New Patient</span>
          <span class="patient-header" *ngIf="mode.edit">Edit Patient</span>
        </div>
        <ion-list class="patient-primary-info-list patient-form-section" lines="none" inset formGroupName="patient">
          <ion-item class="patient-facility">
            <ion-label color="medium" position="stacked">Facility<span style="color:#f1624a">*</span></ion-label>
            <div class="facility-picker">
              <button
                type="button"
                class="facility-picker-trigger"
                [class.placeholder]="!selectedOperationName"
                aria-haspopup="dialog"
                (click)="openFacilitySelectModal()"
              >
                <span>{{ selectedOperationName || 'Select facility' }}</span>
              </button>
            </div>
          </ion-item>
          <ion-item class="patient-medical-record-number">
            <ion-label color="medium" position="stacked">Patient # <span style="color:#f1624a">*</span></ion-label>
            <ion-input type="text" formControlName="patientMedicalRecordNumber" placeholder="Patient #"></ion-input>
          </ion-item>
          <ion-list lines="none" inset formGroupName="patientName">
            <ion-item class="patient-first-name">
              <ion-label color="medium" position="stacked">First Name <span style="color:#f1624a">*</span></ion-label>
              <ion-input
                type="text"
                formControlName="patientFirstName"
                placeholder="First Name"
                inputCapitalizeFirst
              ></ion-input>
            </ion-item>
            <ion-item class="patient-last-name">
              <ion-label color="medium" position="stacked">Last Name <span style="color:#f1624a">*</span></ion-label>
              <ion-input
                type="text"
                formControlName="patientLastName"
                placeholder="Last Name"
                inputCapitalizeFirst
              ></ion-input>
            </ion-item>
          </ion-list>
          <div class="patient-dob-wrapper">
            <ion-item class="patient-dob">
              <ion-label color="medium" position="stacked">Birthday<span style="color:#f1624a">*</span></ion-label>
              <input type="hidden" formControlName="patientDob" />
              <div class="date-input-shell" [class.is-open]="isPatientDobPickerOpen">
                <input
                  class="date-text-input"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday"
                  placeholder="mm/dd/yyyy"
                  [value]="getPatientDobDisplayValue()"
                  (input)="onPatientDobInput($any($event.target).value)"
                  (blur)="onPatientDobInputBlur()"
                />
                <button
                  class="date-picker-toggle"
                  type="button"
                  aria-label="Open birthday date picker"
                  (click)="openPatientDobPicker()"
                ></button>
              </div>
            </ion-item>
            <div class="date-picker-panel patient-dob-picker-panel" *ngIf="isPatientDobPickerOpen">
              <div class="date-picker-header">
                <span class="date-picker-title">Select birthday</span>
                <button class="date-picker-close" type="button" aria-label="Close birthday date picker" (click)="closePatientDobPicker()">
                  Close
                </button>
              </div>
              <ion-datetime
                class="date-picker"
                presentation="date"
                [value]="activePatientDobValue || undefined"
                [max]="getPatientDobPickerMax()"
                [formatOptions]="dischargeDateFormatOptions"
                [showAdjacentDays]="true"
                (ionChange)="onPatientDobPickerChange($event)"
              >
              </ion-datetime>
            </div>
          </div>
          <div class="patient-gender form-row">
            <ion-radio-group class="patient-gender-radio gender-row followup-form-choice-group" formControlName="patientGender">
              <ion-radio
                class="followup-form-choice followup-form-choice--compact gender-option"
                value="male"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Male
              </ion-radio>
              <ion-radio
                class="followup-form-choice followup-form-choice--compact gender-option"
                value="female"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Female
              </ion-radio>
            </ion-radio-group>
          </div>
          <div class="patient-phone-container form-row">
            <ion-item class="patient-country-code phone-field">
              <ion-label color="medium" position="stacked">US (+1)</ion-label>
              <ion-input type="text" maxLength="2" formControlName="patientCountryCode" placeholder="1"></ion-input>
            </ion-item>
            <ion-item class="patient-area-code phone-field">
              <ion-label color="medium" position="stacked">(###)</ion-label>
              <ion-input
                type="text"
                mask="000"
                maxLength="3"
                formControlName="patientAreaCode"
                placeholder="000"
              ></ion-input>
            </ion-item>
            <ion-item class="patient-phone-number phone-field">
              <ion-label color="medium" position="stacked">Primary Contact Phone # <span style="color:#f1624a">*</span></ion-label>
              <ion-input
                type="text"
                formControlName="patientPhoneNumber"
                maxLength="11"
                inputAddPhoneDashes
              ></ion-input>
            </ion-item>
          </div>
          <div class="patient-checkbox-grid form-row followup-form-choice-group">
            <ion-checkbox
              class="followup-form-choice followup-form-choice--compact checkbox-option"
              formControlName="patientIsResponsibleParty"
              labelPlacement="end"
              alignment="start"
              justify="start"
            >
              Responsible Party
            </ion-checkbox>
            <ion-checkbox
              class="speaks-english-toggle followup-form-choice followup-form-choice--compact checkbox-option"
              formControlName="patientSpeaksEnglish"
              (ionChange)="onPatientLanguageToggle()"
              labelPlacement="end"
              alignment="start"
              justify="start"
            >
              Doesn't Speak English
            </ion-checkbox>
          </div>
          <div class="language-section form-row">
            <ion-item
              class="fluent-language"
              [class.show]="patientForm.get('patient.patientSpeaksEnglish').value !== false"
            >
              <ion-label position="stacked">Fluent Language <span style="color:#f1624a">*</span></ion-label>
              <ion-select formControlName="patientFluentLanguage" placeholder="Fluent Language">
                <ion-select-option value="English">English</ion-select-option>
                <ion-select-option value="Spanish">Spanish</ion-select-option>
                <ion-select-option value="Navajo">Navajo</ion-select-option>
              </ion-select>
            </ion-item>
            <div
              class="clear-language"
              *ngIf="
                patientForm.get('patient.patientSpeaksEnglish').value &&
                patientForm.get('patient.patientFluentLanguage').value
              "
            >
              <ion-button type="button" fill="clear" size="small" (click)="clearPatientFluentLanguage()"
                >Clear Language</ion-button
              >
            </div>
          </div>
          <div class="section-header contacts">
            <i class="icon-contacts"></i>
            <span class="contact-header">Contacts</span>
          </div>
          <fieldset class="patient-contacts" formArrayName="patientContacts">
            <ng-template #loadingContacts>
              <span class="loading-contacts">
                Loading Patient Contacts...
              </span>
            </ng-template>
            <ng-container *ngIf="patientContacts; else loadingContacts">
              <ion-list
                lines="none"
                *ngFor="let patientContact of patientContacts; let idx = index"
                formGroupName="{{ idx }}"
                id="additionalPatientContact-{{ idx }}"
              >
                <div class="patient-contact-header-container">
                  <span class="patient-contact-header">Contact {{ idx + 1 }}</span>

                  <ion-item class="remove-contact-label" (click)="removeAdditionalPatientContact(idx)">
                    Remove Contact
                  </ion-item>
                </div>
                <ion-item class="first-name">
                  <ion-label color="medium" position="stacked"
                    >First Name <span style="color:#f1624a">*</span></ion-label
                  >
                  <ion-input type="text" formControlName="patientContactFirstName" inputCapitalizeFirst> </ion-input>
                </ion-item>
                <ion-item class="last-name">
                  <ion-label color="medium" position="stacked">Last Name</ion-label>
                  <ion-input type="text" formControlName="patientContactLastName" inputCapitalizeFirst> </ion-input>
                </ion-item>
                <ion-item class="relationship">
                  <ion-label color="medium" position="stacked"
                    >Relationship <span style="color:#f1624a">*</span></ion-label
                  >
                  <ion-input type="text" formControlName="patientContactRelationship" inputCapitalizeFirst> </ion-input>
                </ion-item>

                <div class="phone-container">
                  <ion-item class="country-code phone-field">
                    <ion-label color="medium" position="stacked">US (+1)</ion-label>
                    <ion-input
                      type="text"
                      maxLength="2"
                      formControlName="patientContactCountryCode"
                      placeholder="1"
                    ></ion-input>
                  </ion-item>
                  <ion-item class="area-code phone-field">
                    <ion-label color="medium" position="stacked">(###)</ion-label>
                    <ion-input type="text" maxLength="3" formControlName="patientContactAreaCode" placeholder="000">
                    </ion-input>
                  </ion-item>
                  <ion-item class="phone-number phone-field">
                    <ion-label color="medium" position="stacked">Phone # <span style="color:#f1624a">*</span></ion-label>
                    <ion-input
                      type="text"
                      inputAddPhoneDashes
                      maxLength="11"
                      formControlName="patientContactPhoneNumber"
                    ></ion-input>
                  </ion-item>
                  <ion-item class="patient-contact-order">
                    <ion-label color="medium" position="stacked">Order</ion-label>
                    <ion-input type="number" formControlName="patientContactOrder" [value]="idx + 1"></ion-input>
                  </ion-item>
                </div>
                <div class="patient-contact-flags">
                  <ion-checkbox
                    class="responsible-party-toggle followup-form-choice followup-form-choice--compact"
                    formControlName="patientContactResponsiblePartyBoolean"
                    (ionChange)="syncContactFlags(idx)"
                    labelPlacement="end"
                    alignment="start"
                    justify="start"
                  >
                    Responsible Party
                  </ion-checkbox>
                </div>
              </ion-list>
              <ion-item class="ion-float-right add-additional-contact" (click)="addAdditionalPatientContact()"
                >Add Contact</ion-item
              >
            </ng-container>
          </fieldset>

          <div class="section-header">
            <i class="icon-insurance"></i>
            <span class="discharge-header">Hospital Admitted</span>
          </div>
          <fieldset class="insurance-info" formGroupName="hospitalAdmitted">
            <ion-list lines="none" inset>
              <ion-item class="primary-insurance">
                <ion-label color="medium" position="stacked">Hospital Admitted</ion-label>
                <ion-input formControlName="patientHospitalAdmitted" maxLength="255" inputCapitalizeFirst></ion-input>
              </ion-item>
            </ion-list>
          </fieldset>
          <div class="section-header">
            <i class="icon-discharge-calendar"></i>
            <span class="discharge-header">Discharge Info</span>
          </div>
          <fieldset class="patient-discharge" formGroupName="dischargeInfo">
            <div class="discharged-ama">
              <ion-label class="discharged-label" color="medium" position="stacked">
                Discharged Against Medical Advice? <span style="color:#f1624a">*</span>
              </ion-label>
              <ion-radio-group
                class="discharged-ama-options followup-form-choice-group"
                formControlName="patientDischargedAma"
              >
                <ion-radio
                  class="followup-form-choice followup-form-choice--compact"
                  value="1"
                  labelPlacement="end"
                  alignment="start"
                  justify="start"
                >
                  Yes
                </ion-radio>
                <ion-radio
                  class="followup-form-choice followup-form-choice--compact"
                  value="0"
                  labelPlacement="end"
                  alignment="start"
                  justify="start"
                >
                  No
                </ion-radio>
              </ion-radio-group>
            </div>
            <ion-list class="discharge-dates" inset lines="none">
              <div class="patient-discharge-dates-container">
                <ion-item class="discharge-admit-date">
                  <ion-label color="medium" position="stacked">Admitted <span style="color:#f1624a">*</span></ion-label>
                  <input type="hidden" formControlName="patientAdmitDate" />
                  <div class="date-input-shell discharge-date-input-shell" [class.is-open]="activeDischargeDateControl === 'patientAdmitDate'">
                    <input
                      class="date-text-input discharge-date-text-input"
                      type="text"
                      inputmode="numeric"
                      placeholder="mm/dd/yyyy"
                      [value]="getDischargeDateDisplayValue('patientAdmitDate')"
                      (input)="onDischargeDateInput('patientAdmitDate', $any($event.target).value)"
                      (blur)="onDischargeDateInputBlur('patientAdmitDate')"
                    />
                    <button
                      class="date-picker-toggle discharge-date-picker-toggle"
                      type="button"
                      aria-label="Open admit date picker"
                      (click)="openDischargeDatePicker('patientAdmitDate')"
                    ></button>
                  </div>
                </ion-item>
                <ion-item class="discharge-discharge-date">
                  <ion-label color="medium" position="stacked"
                    >Discharged <span style="color:#f1624a">*</span></ion-label
                  >
                  <input type="hidden" formControlName="patientDischargeDate" />
                  <div class="date-input-shell discharge-date-input-shell" [class.is-open]="activeDischargeDateControl === 'patientDischargeDate'">
                    <input
                      class="date-text-input discharge-date-text-input"
                      type="text"
                      inputmode="numeric"
                      placeholder="mm/dd/yyyy"
                      [value]="getDischargeDateDisplayValue('patientDischargeDate')"
                      (input)="onDischargeDateInput('patientDischargeDate', $any($event.target).value)"
                      (blur)="onDischargeDateInputBlur('patientDischargeDate')"
                    />
                    <button
                      class="date-picker-toggle discharge-date-picker-toggle"
                      type="button"
                      aria-label="Open discharge date picker"
                      (click)="openDischargeDatePicker('patientDischargeDate')"
                    ></button>
                  </div>
                </ion-item>
                <img class="equal-sign" src="/assets/icon-equal-sign@2x.png" />
                <ion-item class="discharge-total-days">
                  <ion-label color="medium" position="stacked">Total Days</ion-label>
                  <ion-input formControlName="patientTotalDays" [readonly]="true"></ion-input>
                </ion-item>
                <div class="date-picker-panel discharge-date-picker-panel" *ngIf="activeDischargeDateControl">
                  <div class="date-picker-header discharge-date-picker-header">
                    <span class="date-picker-title discharge-date-picker-title">{{ getActiveDischargeDateTitle() }}</span>
                    <button
                      class="date-picker-close discharge-date-picker-close"
                      type="button"
                      aria-label="Close date picker"
                      (click)="closeDischargeDatePicker()"
                    >
                      Close
                    </button>
                  </div>
                  <ion-datetime
                    class="date-picker discharge-date-picker"
                    presentation="date"
                    [value]="activeDischargeDateValue || undefined"
                    [min]="getActiveDischargeDateMin()"
                    [max]="getActiveDischargeDateMax()"
                    [formatOptions]="dischargeDateFormatOptions"
                    [showAdjacentDays]="true"
                    (ionChange)="onDischargeDatePickerChange($event)"
                  >
                  </ion-datetime>
                </div>
              </div>
              <ion-item class="discharge-to-location" *ngIf="dischargeLabels">
                <ion-label color="medium" position="stacked"
                  >Discharged To: <span style="color:#f1624a">*</span></ion-label
                >
                <ion-radio-group formControlName="patientDischargedTo">
                  <div class="discharge-location-grid followup-form-choice-grid">
                    <ion-radio
                      class="discharge-location followup-form-choice"
                      *ngFor="let dischargeLabel of dischargeLabels"
                      [value]="dischargeLabel.patientDischargeLabelId"
                      labelPlacement="end"
                      alignment="start"
                      justify="start"
                    >
                      {{ dischargeLabel.patientDischargeLabel }}
                    </ion-radio>
                  </div>
                </ion-radio-group>
              </ion-item>
            </ion-list>
          </fieldset>
          <div class="section-header discharge">
            <i class="icon-medical"></i>
            <span class="contact-header">Medical Condition</span>
          </div>
          <fieldset class="patient-medical-conditions">
            <ion-list class="patient-medical-conditions" lines="none" inset>
              <div class="checkboxes-inline followup-form-choice-grid" formGroupName="patientMedicalConditions">
                <ion-checkbox
                  class="followup-form-choice"
                  formControlName="cardiacBoolean"
                  labelPlacement="end"
                  alignment="start"
                  justify="start"
                >
                  Cardiac
                </ion-checkbox>
                <ion-checkbox
                  class="followup-form-choice"
                  formControlName="sepsisBoolean"
                  labelPlacement="end"
                  alignment="start"
                  justify="start"
                >
                  Sepsis
                </ion-checkbox>
                <ion-checkbox
                  class="followup-form-choice"
                  formControlName="pulmonaryBoolean"
                  labelPlacement="end"
                  alignment="start"
                  justify="start"
                >
                  Pulmonary
                </ion-checkbox>
                <ion-checkbox
                  class="followup-form-choice"
                  formControlName="otherBoolean"
                  labelPlacement="end"
                  alignment="start"
                  justify="start"
                >
                  Other
                </ion-checkbox>
              </div>
              <ion-item class="textarea-item">
                <ion-label color="medium" position="stacked"
                  >Primary Diagnosis <span style="color:#f1624a">*</span>
                </ion-label>
                <ion-textarea
                  [autoGrow]="true"
                  formControlName="patientPrimaryDiagnosis"
                  spellcheck="true"
                  autocorrect="on"
                  autocapitalize="sentences"
                ></ion-textarea>
              </ion-item>
              <ion-item class="textarea-item" *ngIf="patient">
                <ion-label color="medium" position="stacked">Discharged Condition </ion-label>
                <ion-textarea
                  [autoGrow]="true"
                  formControlName="patientDischargedCondition"
                  spellcheck="true"
                  autocorrect="on"
                  autocapitalize="sentences"
                ></ion-textarea>
              </ion-item>
            </ion-list>
          </fieldset>
          <fieldset class="patient-intake-questions">
            <div class="section-header">
              <i class="icon-questions"></i>
              <span class="contact-header">Intake Questions</span>
            </div>
            <ion-list lines="none" class="patient-intake-questions" inset formArrayName="patientIntakeQuestionAnswers">
              <ion-item
                *ngFor="let patientIntakeQuestion of patientIntakeQuestions; let idx = index"
                [formGroupName]="idx"
              >
                <div class="call-question-body-container">
                  <div class="call-question">
                    <ng-container *ngIf="patientIntakeQuestion.patientQuestionTypeLabel == 'rating'">
                      <ion-label color="medium">{{ patientIntakeQuestion.patientIntakeQuestion }}</ion-label>
                      <ion-list class="rating" lines="none">
                        <ion-radio-group
                          formControlName="{{ patientIntakeQuestion.patientIntakeQuestionId }}"
                          [value]="1"
                        >
                          <ion-item *ngFor="let rating of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
                            <ion-radio class="rating-option rating-button-{{ rating }}" value="{{ rating }}">
                            </ion-radio>
                          </ion-item>
                        </ion-radio-group>
                      </ion-list>
                    </ng-container>
                    <ng-container *ngIf="patientIntakeQuestion.patientQuestionTypeLabel == 'boolean'">
                      <ion-label color="medium">{{ patientIntakeQuestion.patientIntakeQuestion }}</ion-label>
                      <ion-list lines="none">
                        <ion-radio-group formControlName="{{ patientIntakeQuestion.patientIntakeQuestionId }}">
                          <ion-item class="boolean">
                            <ion-radio class="intake-boolean-radio radio-button-yes" value="1"></ion-radio>
                          </ion-item>
                          <ion-item class="boolean">
                            <ion-radio value="0" class="intake-boolean-radio radio-button-no"></ion-radio>
                          </ion-item>
                        </ion-radio-group>
                      </ion-list>
                    </ng-container>
                  </div>
                </div>
              </ion-item>
            </ion-list>
          </fieldset>
          <fieldset class="need-to-know">
            <div class="section-header">
              <i class="icon-info"></i>
              <span class="contact-header">Need To Know</span>
            </div>
            <ion-textarea
              [autoGrow]="true"
              formControlName="patientNeedToKnow"
              spellcheck="true"
              autocorrect="on"
              autocapitalize="sentences"
            ></ion-textarea>
          </fieldset>
          <ion-checkbox
            class="is-active followup-form-choice followup-form-choice--compact ion-float-right"
            formControlName="patientActive"
            labelPlacement="end"
            alignment="start"
            justify="start"
          >
            Active?
          </ion-checkbox>
        </ion-list>
        <div class="form-button-controls">
          <button type="button" class="primary button" [disabled]="isSaving" (click)="onFormSubmit()">
            Save
          </button>
          <button type="button" *ngIf="mode.edit" class="secondary button" (click)="cancel()">
            Cancel
          </button>
        </div>
      </form>
    </ion-col>
    <ion-col class="avatar-col">
      <div class="avatar-container">
        <app-patient-avatar-upload *ngIf="patient" [avatarExists]="avatarExists" [patient]="patient">
        </app-patient-avatar-upload>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
